import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { exitFullscreen, launchFullscreen } from './utils';
@Component({
  selector: 'm-operations-fullscreen',
  template: `
    <ng-container *ngIf="!fullscreen; else elseTemplate">
      <i nz-icon nzType="fullscreen" nzTheme="outline" (click)="execFullscreen()"></i>
    </ng-container>
    <ng-template #elseTemplate>
      <i nz-icon nzType="fullscreen-exit" nzTheme="outline" (click)="exitFullscreen()"></i>
    </ng-template>
  `
})
export class MOperationsFullscreenComponent implements OnInit, OnDestroy {
  @Input() elementSelector!: string;

  private destroy$ = new Subject();
  fullscreen = false;
  fullscreenElement: NzSafeAny;
  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.fullscreen = !!document.fullscreenElement;
    this.fullscreenElement = this.elementSelector ? document.querySelector(this.elementSelector) : document.querySelector('body');
    this.registerFullScreenEvent();
  }

  private registerFullScreenEvent(): void {
    fromEvent<Event>(document, 'fullscreenchange')
      .pipe(takeUntil(this.destroy$))
      .subscribe(e => {
        if (e) {
          this.fullscreen = !!document.fullscreenElement;
        }
        this.fullscreenElement.className = `${this.fullscreenElement.className.replace('m-operations-fullscreen', '')} ${
          this.fullscreen ? 'm-operations-fullscreen' : ''
        }`;
        this.cdr.detectChanges();
      });
  }

  execFullscreen(): void {
    this.fullscreen = true;
    launchFullscreen(this.fullscreenElement);
  }

  exitFullscreen(): void {
    this.fullscreen = false;
    exitFullscreen();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
